module.exports = __webpack_public_path__ + "static/media/city-star.92e77289.png";